var app = angular.module("leonardo");

var VendorListFilters = function(
  $scope,
  $controller
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        }
      ]
    },
    {
      id: 'vendor_name',
      name: 'Vendor Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Vendor name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];

};

app.controller('VendorListFilters', [
  '$scope',
  '$rootScope',
  VendorListFilters
]);
